import { render, staticRenderFns } from "./Gen4Outline.vue?vue&type=template&id=22a4fe52&scoped=true"
import script from "./Gen4Outline.vue?vue&type=script&lang=js"
export * from "./Gen4Outline.vue?vue&type=script&lang=js"
import style0 from "./Gen4Outline.vue?vue&type=style&index=0&id=22a4fe52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4fe52",
  null
  
)

/* custom blocks */
import block0 from "./Gen4Outline.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports